<template>
  <div>
    <NativeBar select="textbook" />
    <van-skeleton title :row="20" :loading="loading">

      <div class="ProgramRect">
        <div v-for="typeItem in list" :key="typeItem.cat" class="typeRect">
          <div class="title mainColor pageTitle1">{{ $t('diveType.'+typeItem.cat) }} </div>
          <div class="programList">
            <div v-for="item in typeItem.list" :key="item.courseId" class="program">
              <div class="oneProgram">
                <img :src="item.image" @click="onVisitTextbook(item.programId)">
                <div class="viewbarBack">
                  <div class="viewbar" :style="'width:'+item.viewprogress+'%'" />
                </div>
                <div class="examRect">
                  <div v-for="i in item.totalquizes" :key="i" class="examItem" :style="i<=item.passedquizes?'background-color:#0092FA;':''" />
                </div>
                <!-- <span>{{ item.viewprogress }}</span><br>
                <span>{{ item.passedquizes }}/{{ item.totalquizes }}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-skeleton>
    <div class="downEmptyRect" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { initPage } from '@/utils/base'
import NativeBar from '@/components/NativeBar'
import { Button, Skeleton, Toast } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [Toast.name]: Toast,
    NativeBar
  },
  data() {
    return {
      list: [],
      baseCircle: 100,
      loading: true
    }
  },
  created() {
    initPage(true)
    this.loadData()
  },
  // beforeRouteLeave(to, from, next) {
  //   Toast.clear()
  // },
  methods: {
    loadData() {
      Toast.loading({
        mask: true,
        duration: 0,
        message: '正在与SSI同步您的教材列表请等待...'
      })
      request({
        url: '/user/getUserProgramList',
        method: 'get'
      }).then(response => {
        console.log(response)

        this.loading = false
        Toast.clear()
        if (!response.success) {
          return
        }
        this.list = response.data
      })
    },
    onVisitTextbook(id) {
      console.log("click,",id)
      this.$router.replace('/textbook/textbook/' + id + '?backurl=/textbook/index')
    }
  }
}
</script>
<style scoped>
.viewbarBack{
  position: relative;
  width: 100%;
  height: 0.4em;
  background-color: #ccc;
}
.examRect{
  margin-top: 0.1em;
  width: 100%;
  height: 0.4em;
  display: -webkit-flex;
  display: flex;
}
.examRect .examItem{
  margin-right:0.2em;
  height: 0.4em;
  width: 20em;
  background-color: #eee;
}
.examRect .examItem:last-child{
  margin-right:0;
}
.viewbarBack .viewbar{
  position:absolute;
  left: 0;
  top:0;
  width: 80%;
  height: 0.4em;
  background-color: #0092FA;
}

.typeRect{
padding: 0 0.5em;
}
.typeRect .title{
  padding: 1em 0.5em;
}
.programList{
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.programList img{
  vertical-align:top;
}
.program{
 width: 50%;
 text-align: center;
 margin-top:0.5em;
 position: relative;
}
.oneProgram{
  padding: 0.3em;
}
.program img{

  width: 100%;
}

.downEmptyRect{
  height: 3em;
}
</style>
